import {createUseStyles} from 'react-jss';
import MediaQueries from '../../style-helper/MediaQueries';
import Spacing from '../../style-helper/Spacing';
import baseInputStyles from '../../form/Form.styles';
import Width from '../../style-helper/Width';

export default createUseStyles({
  pcaInput: {
    ...baseInputStyles,
    width: Width.half,
  },
  buttonContainer: {
    display: 'inline-block',
    margin: '0 0 0 4%',
    padding: '0',
    verticalAlign: 'middle',
    width: Width.half,
  },
  findAddressButton: {
    minHeight: 42,
    padding: 6,
    [MediaQueries.phone]: {
      padding: 6, // Override mobile rules too -- Original comment
    },
  },
  pcaContainer: {
    margin: [Spacing.double, 0],
  },
  selectAddressLabel: {
    marginTop: '1em',
  },
});
